/** @jsxImportSource @emotion/react */

import { useMutation } from '@apollo/client'
import { FC, useCallback } from 'react'
import { removeVideo, removeVideoVariables } from '__generatedTypes__/removeVideo'
import { updateVideo, updateVideoVariables } from '__generatedTypes__/updateVideo'
import { REMOVE_VIDEO, UPDATE_VIDEO } from 'queries/video'
import { toast } from 'utils/toast'
import { IResourceData, IVideoCategoryProps } from '../types'
import withVideoCategoryContentCheck from '../withVideoCategoryContentCheck'
import * as commonClasses from '../commonStyles'
import VideoResourceForm from './VideoResourceForm'

const VideoResourceEdit: FC<IVideoCategoryProps> = ({ videoCategory, content, redirectToVideoDashboard }) => {
  const [updateVideo] = useMutation<updateVideo, updateVideoVariables>(UPDATE_VIDEO)
  const [removeVideo] = useMutation<removeVideo, removeVideoVariables>(REMOVE_VIDEO)

  //TODO to add error handling
  const handleSubmit = useCallback(
    async (fieldsValues: IResourceData) => {
      try {
        await updateVideo({
          variables: {
            updateVideoInputFieldName: {
              id: content.id,
              title: fieldsValues.title,
              resourseURL: fieldsValues.resourseURL,
            },
          },
        })

        redirectToVideoDashboard()
        toast.success('Video resource updated successfully')
      } catch (error) {
        toast.error('Failed to update video resource')
      }
    },
    [content]
  )

  const handleRemoveResource = useCallback(async () => {
    try {
      await removeVideo({
        variables: {
          removeVideoId: content.id,
        },
      })

      redirectToVideoDashboard()
      toast.success('Video resource removed successfully')
    } catch (error) {
      toast.error('Failed to remove video resource')
    }
  }, [content])

  return (
    <div css={commonClasses.containerPadding}>
      <VideoResourceForm
        videoCategory={videoCategory}
        handleSubmit={handleSubmit}
        initialValues={content}
        onDeleteClick={handleRemoveResource}
      />
    </div>
  )
}

export default withVideoCategoryContentCheck(VideoResourceEdit)
